import { gql } from "@apollo/client";

export const GET_USUARIO_DELEGACION_ORIGEN = gql`
query GetUsuarioDelegacionOrigen ($idUsuario: Int!) {
    usuarioFull (idUsuario: $idUsuario)
        {
            success,
            error,
            valorEsperado {
                delegacionOrigen,
            }
        }
}`;